<template>
  <v-navigation-drawer
    v-model="drawer"
    disable-resize-watcher
    disable-route-watcher
    fixed
    temporary
    right
    class="individual-manage-drawer grey lighten-4"
    :width="width"
    v-if="individualId"
  >
    <v-toolbar flat color="grey lighten-4">
      <v-btn icon @click="closeDrawer">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-row no-gutters class="grey lighten-4 pt-5">
      <v-container>
        <edit-individual @close="closeDrawer" :individual-id="individualId" />
        <v-divider class="my-4" />
        <user-overview
          ref="userOverview"
          :user-lessons="userLessons"
          :learning-areas="learningAreas"
        />
        <result-lesson :student-lessons="studentLessons" />
      </v-container>
    </v-row>
  </v-navigation-drawer>
</template>
<script>
import EditIndividual from './EditIndividual'
import UserOverview from '@/modules/student/views/manage_student/student_overview/UserOverview'
import UserLesson from '@/modules/lesson/models/UserLesson'
import ResultLesson from '@/modules/student/views/manage_student/result_lesson_card/ResultLesson'

export default {
  name: 'ManageIndividual',
  components: {
    EditIndividual,
    UserOverview,
    ResultLesson
  },
  props: {
    individualId: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: true
    }
  },
  data() {
    return {
      drawer: false,
      width: 300,
      learningAreas: []
    }
  },
  watch: {
    drawer(val) {
      if (!val) {
        let query = Object.assign({}, this.$route.query)
        delete query.individualId
        this.$router.push({ query: query })
      }
    }
  },
  computed: {
    userLessons() {
      const userLessons = UserLesson.query()
        .with('lesson')
        .where('entity_id', this.individualId)
        .where('is_completed', true)
        .get()
      return userLessons
    },
    studentLessons() {
      return UserLesson.query()
        .where('entity_id', this.individualId)
        .orderBy('completed_at', 'desc')
        .get()
    }
  },
  async mounted() {
    this.width = window.innerWidth * 0.9
    window.addEventListener('resize', () => {
      this.width = window.innerWidth * 0.9
    })
  },
  methods: {
    closeDrawer() {
      this.$emit('update:individualId', null)
      this.drawer = false
    },
    async initialise() {
      await UserLesson.dispatch('getLessonsForChildId', this.individualId)
      // parameters here are not important just passing it so validation does not fail
      this.learningAreas = await this.$axios.get(
        `api/parents/reports?child_id=${this.individualId}&type=individualLessons&date_start=2019-01-01&date_end=2019-01-01`
      )
      this.$refs.userOverview.initialiseGraphs()
    }
  }
}
</script>

<style lang="scss" scoped>
.individual-manage-drawer {
}
</style>
